<script>
export default {};
</script>

<template>
    <router-view></router-view>
</template>
